import axios from "axios";
const api = axios.create({
  //   baseURL: "https://backend.codxegy.com",
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  headers: {
    "Access-Control-Allow-Credentials": true,
    "Access-Control-Allow-Origin": "*",
  },
});

// Attach the fixer JWT to every outgoing request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("isLoggedIn");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default api;
